import React from "react";
import * as styles from "./bio.module.css";

const BIO = `Milky Haze, originally from Virginia, is a rising electronic music artist in the Southeast. Drawing roots from Psychedelic Rock, Milky infuses his style with Electro-Soul and Experimental Bass to create harmonic frequencies. His mission is to remind the world that we are all connected and share the same energy through love and sacred vibration

Milky uses his saxophone and guitar to take you on a ride through his funky space bass melodies. He is pushing the boundaries of creative minds to think beyond their limits and question everything they have ever been taught. It is his goal to bring awareness to as many people as time allows that their only limitation is their imagination and how anything they want can be manifested. Milky is taking his live performance"s global and showing everyone that Universe means one song and that the journey is the destination.`;

const Bio = () => {
  return (
    <section id="bio" className="section-wrapper">
      <p className={styles.bioText}>{BIO}</p>
    </section>
  );
};

export default Bio;
